// Secure storage bridge customer ID management
import { secureStorage } from "@/lib/security/dataProtection";

export const setBridgeCustomerId = (id: string): void => {
    const existing = secureStorage.getItem<string>("bridge_customer_id");
    if (existing === id) return;
    secureStorage.setItem("bridge_customer_id", id, { sensitive: true });
};

// SECURITY: Use secure storage system instead of manual localStorage clearing
export const clearUserPII = (): void => {
  try {
    // Clear sensitive data manually
    if (typeof window !== 'undefined') {
      sessionStorage.clear();
    }
    
    // Additionally, clear any remaining legacy localStorage keys
    const legacyKeys = [
      'supabase.auth.token',
      'sb-auth-token',
      'auth_token', 
      'user_session',
      'bridgeStatus',
      'bridgeLinks',
      'pendingKyc',
      'bridgeCustomerId',
      'bridgeLinksEmail',
      'liquid.bridge_customer_id',
      'liquid.profile_name'
    ];
    
    legacyKeys.forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
    
    console.log('PII cleared from browser storage');
  } catch (error) {
    console.warn('Error clearing PII from storage:', error);
  }
};
